export const servicePages = {
  firstHomeBuyers: {
    title: 'First Home Buyer Support | L.A Property Law',
    eyebrow: 'first home buyers',
    heroTitle: 'Clear guidance for your first property purchase.',
    intro:
      'Residential conveyancing support that explains the contract, the process and the decisions ahead, from your first review through to settlement.',
    sectionHeading: 'Support for every stage of your first purchase.',
    sectionIntro:
      'Understand what you are signing, what needs attention and what happens next before you commit.',
    items: [
      {
        title: 'Contract and disclosure review',
        body: 'The contract and relevant disclosure documents are reviewed so key obligations, conditions and risks are clear before you sign.',
      },
      {
        title: 'First home buyer guidance',
        body: 'The process is explained in plain language, including the steps, documents and decisions that may be unfamiliar on a first purchase.',
      },
      {
        title: 'Auction and private sale support',
        body: 'Advice is tailored to how you are buying, including the importance of reviewing an auction contract before bidding.',
      },
      {
        title: 'Settlement coordination',
        body: 'Documents, dates, adjustments and settlement requirements are coordinated through to completion.',
      },
    ],
  },
  smsfTrustProperty: {
    title: 'SMSF and Trust Property | L.A Property Law',
    eyebrow: 'smsf and trusts',
    heroTitle: 'Property transactions involving SMSFs and trusts.',
    intro:
      'Legal support for property purchases involving self-managed super funds, family trusts and unit trusts, with clear coordination across the transaction.',
    sectionHeading: 'Complex structures handled with coordinated advice.',
    sectionIntro:
      'These transactions often involve legal, accounting, lending and compliance considerations that need to work together.',
    items: [
      {
        title: 'SMSF property purchases',
        body: 'Property transactions involving self-managed super funds are reviewed with attention to the purchasing structure and supporting documents.',
      },
      {
        title: 'Family and unit trusts',
        body: 'Trust-related purchases are coordinated with the relevant legal documents and ownership details in view.',
      },
      {
        title: 'Professional coordination',
        body: 'The legal team works alongside your accountant, financial adviser and lender so responsibilities and timing remain aligned.',
      },
      {
        title: 'Contract through settlement',
        body: 'Contract review, transaction documents, dates and settlement requirements are managed as one coordinated process.',
      },
    ],
  },
  commercialProperty: {
    title: 'Commercial Property Conveyancing | L.A Property Law',
    eyebrow: 'commercial property',
    heroTitle: 'Commercial property advice for complex transactions.',
    intro:
      'Specialised commercial property services for businesses and investors, with legal guidance across purchases, sales, leases and development matters.',
    sectionHeading: 'Commercial property support matched to the transaction.',
    sectionIntro:
      'Commercial matters carry different obligations, timeframes and risks from residential conveyancing.',
    items: [
      {
        title: 'Commercial sales and purchases',
        body: 'Contracts, disclosure material and transaction requirements are reviewed and coordinated for commercial acquisitions and disposals.',
      },
      {
        title: 'Commercial leases',
        body: 'Lease documents and key obligations are considered so the commercial arrangement is understood before commitment.',
      },
      {
        title: 'Development projects',
        body: 'Property transactions connected with development projects are coordinated with the broader legal and commercial context in view.',
      },
      {
        title: 'Risk and deadline management',
        body: 'Conditions, dates and transaction risks are identified early and managed through to completion.',
      },
    ],
  },
  propertyTransfers: {
    title: 'Property Transfers | L.A Property Law',
    eyebrow: 'property transfers',
    heroTitle: 'Property transfers handled with legal clarity.',
    intro:
      'Legal support for transferring property interests, with the ownership details, documents and completion steps coordinated carefully.',
    sectionHeading: 'A clear process for changing property ownership.',
    sectionIntro:
      'The transaction is reviewed in context so the documents and ownership outcome reflect what is intended.',
    items: [
      {
        title: 'Ownership and title review',
        body: 'The existing title and proposed ownership details are considered before transfer documents are prepared.',
      },
      {
        title: 'Transfer documentation',
        body: 'Required documents are prepared and coordinated for the relevant property and transaction circumstances.',
      },
      {
        title: 'Related-party transfers',
        body: 'Transfers between individuals, family members or related entities are handled with attention to the legal structure involved.',
      },
      {
        title: 'Completion coordination',
        body: 'Signing, lodgement and completion requirements are managed so the transfer reaches its intended outcome.',
      },
    ],
  },
  subdivisions: {
    title: 'Property Subdivisions | L.A Property Law',
    eyebrow: 'subdivisions',
    heroTitle: 'Subdivision support from documentation to completion.',
    intro:
      'Property subdivision services for owners and developers, with the legal documents, parties and completion requirements coordinated clearly.',
    sectionHeading: 'Legal support for each stage of a subdivision.',
    sectionIntro:
      'Subdivision matters often involve multiple professionals and regulatory steps that need to remain aligned.',
    items: [
      {
        title: 'Subdivision documentation',
        body: 'Legal documents connected with the proposed subdivision are reviewed and coordinated for the matter.',
      },
      {
        title: 'Professional coordination',
        body: 'The legal team works with relevant surveyors, advisers and other parties so responsibilities remain clear.',
      },
      {
        title: 'Transaction requirements',
        body: 'Conditions, ownership details and completion steps are considered in the context of the subdivision.',
      },
      {
        title: 'Completion support',
        body: 'Documents and milestones are managed through to the completion of the legal work.',
      },
    ],
  },
  solicitorCertificates: {
    title: 'Solicitor Certificates | L.A Property Law',
    eyebrow: 'legal certification',
    heroTitle: 'Independent legal explanation and certification.',
    intro:
      'Solicitor certificates and related legal advice provided by qualified solicitors, with the document and its obligations explained clearly.',
    sectionHeading: 'Know what the document means before you certify.',
    sectionIntro:
      'Certification is more than a signature. The document, obligations and relevant risks need to be understood first.',
    items: [
      {
        title: 'Document review',
        body: 'The relevant document is reviewed before the certification process proceeds.',
      },
      {
        title: 'Independent explanation',
        body: 'Key terms, obligations and potential consequences are explained in clear language.',
      },
      {
        title: 'Questions answered',
        body: 'You can raise questions about the document and the certification process with a qualified solicitor.',
      },
      {
        title: 'Legal certification',
        body: 'Where appropriate, the required solicitor certificate is completed after the advice process.',
      },
    ],
  },
}
